import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { heroImages } from '../data/mock';
import { Button } from './ui/button';
import { ArrowRight, ChevronDown } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <img
          src={heroImages.main}
          alt="Professional roofing work"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="container mx-auto px-8">
        <div className="hero-content">
          <h1 className="hero-title">
            {t.hero.title}
            <br />
            {t.hero.subtitle}
          </h1>
          <p className="body-large mb-8">
            {t.hero.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollToSection('quote')}
              className="btn-primary flex items-center justify-center space-x-2"
            >
              <span>{t.hero.cta}</span>
              <ArrowRight className="w-5 h-5" />
            </Button>
            <Button
              onClick={() => scrollToSection('projects')}
              variant="secondary"
              className="btn-secondary"
            >
              {t.hero.secondary}
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollToSection('services')}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-[#60a5fa] animate-bounce cursor-pointer"
        aria-label="Scroll down"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
};

export default Hero;
